import { ReactNode } from 'react';
import { contextFactory } from '@frontend/design-system';

export type TrendsContextValue<T extends string> = {
  activeTab: T;
  isOpen: boolean;
  isLoading: boolean;
  setActiveTab: (tab: T) => void;
  toggleOpen: () => void;
};

export const [TrendsContext, useTrendsContext] = contextFactory<TrendsContextValue<any>>(
  'PatientCallTrends must be rendered inside a <PatientCallTrends> provider'
);

export const TrendsProvider = <T extends string>({
  children,
  value,
}: {
  children: ReactNode;
  value: TrendsContextValue<T>;
}) => {
  return <TrendsContext.Provider value={value}>{children}</TrendsContext.Provider>;
};
